import { Card as CardType } from 'legacy/common/types/models';

import Card from './Card';

const CURRENCY_COUNTRY = {
  CAD: 'CA',
  USD: 'US'
};

const FEE_MESSAGE = (
  <p className="text-small text-black mt-4">
    Note: Extra fees may apply with international cards.
  </p>
);

type PaymentMethodProps = {
  cards: CardType[];
  loading: boolean;
  selectedCardId: string;
  purchaseCurrency: string;
  addCard: () => void;
  navigateToSelectPaymentMethod: () => void;
};

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  cards,
  loading,
  selectedCardId,
  purchaseCurrency,
  addCard,
  navigateToSelectPaymentMethod
}) => {
  const renderPaymentMethod = (
    cards: CardType[],
    selectedCardId: string,
    options: { disabled: boolean }
  ) => {
    const defaultCard = cards?.find((card) => card.default);

    if (selectedCardId) {
      const card = cards?.find((card) => card?._id === selectedCardId);

      return (
        <div>
          <Card
            last4={card?.last4}
            disabled={options.disabled}
            onClick={() => navigateToSelectPaymentMethod()}
          />
          {CURRENCY_COUNTRY[purchaseCurrency] !== card.country && FEE_MESSAGE}
        </div>
      );
    }

    if (defaultCard) {
      return (
        <div>
          <Card
            last4={defaultCard?.last4}
            disabled={options.disabled}
            onClick={() => navigateToSelectPaymentMethod()}
          />
          {CURRENCY_COUNTRY[purchaseCurrency] !== defaultCard.country &&
            FEE_MESSAGE}
        </div>
      );
    }

    return <Card title="Select Payment Method" onClick={() => addCard()} />;
  };

  return (
    <div className="cursor-pointer mt-2">
      <div className="text-base text-gray-500">Confirm Payment Method</div>
      {renderPaymentMethod(cards, selectedCardId, {
        disabled: loading
      })}
    </div>
  );
};

export default PaymentMethod;
